//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    cur: {
      type: String,
      default: '首页'
    }
  },
  data () {
    return {
      menuList: [
        {
          icon: require('../../../assets/lyx-img/shouye.png'),
          activeIcon: require('../../../assets/lyx-img/shouye-a.png'),
          name: '首页',
          url: '/'
        },
        {
          icon: require('../../../assets/lyx-img/daolan.png'),
          activeIcon: require('../../../assets/lyx-img/daolan.png'),
          name: '导览',
          url: '/guide'
        },
        
        {
          icon: require('../../../assets/lyx-img/chengshi.png'),
          activeIcon: require('../../../assets/lyx-img/chengshi-a.png'),
          name: '城市',
          url: '/cityServices'
        },
        {
          icon: require('../../../assets/lyx-img/wode.png'),
          activeIcon: require('../../../assets/lyx-img/wode-a.png'),
          name: '我的',
          url: '/center'
        },
      ]
    }
  }
}
